//Facts & Figures Timeline
var timeLine = $('.facts-figures-timeline');

if(timeLine.length > 0) {
    var timeLineItems = $('.facts-figures-timeline-items');
    timeLineItems.slick({
      dots: true,
      infinite: false,
      arrow:true,
      slidesToShow: 3,
      slidesToScroll: 1,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ],
    });

}
